import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../style/contactPage/contactpage.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";

function ContactDownloads() {
  return (
    <div>
      <Row className="text-box-div download-div d-flex justify-content-between">
        {/* <Col lg={3} md={12} sm={12} className="download-title">
          <p>Downloads</p>
        </Col>

        <Col lg={3} md={12} sm={12} className="text-box relative">
          <p>Apply Online</p>
          <div className="absolute icn">
            <FontAwesomeIcon
              className="absolute"
              style={{ top: "13px", left: "13px" }}
              icon={faArrowRight}
            />
          </div>
        </Col>

        <Col lg={3} md={12} sm={12} className="text-box relative">
          <p>
            Download <br /> Application Form
          </p>
          <div className="absolute icn">
            <FontAwesomeIcon
              className="absolute"
              style={{ top: "13px", left: "13px" }}
              icon={faArrowRight}
            />
          </div>
        </Col>
        <Col lg={3} md={12} sm={12} className="text-box relative">
          <p>
            Upload <br />
            Application Form
          </p>
          <div className="absolute icn">
            <FontAwesomeIcon
              className="absolute"
              style={{ top: "13px", left: "13px" }}
              icon={faArrowRight}
            />
          </div>
        </Col> */}
      </Row>
    </div>
  );
}

export default ContactDownloads;
